<template>
  <div class="tabItem">
    <div class="top">
      <div class="lxList minBox">
        <div class="lxItem">
          <div class="icon">
            <img src="~@/assets/img/aboutUs/lxIcon1.png" alt />
          </div>
          <div class="name">联系方式</div>
          <div class="info">Tel：13065706575</div>
        </div>
        <div class="lxItem">
          <div class="icon ic_b">
            <img src="~@/assets/img/aboutUs/location.png" alt />
          </div>
          <div class="name">公司地址</div>
          <div class="info">杭州市上城区同协金座13幢14F</div>
        </div>
        <div class="lxItem">
          <div class="icon">
            <img src="~@/assets/img/aboutUs/lxIcon3.png" alt />
          </div>
          <div class="name">电子邮箱</div>
          <div class="info">Email：admin@51ysscw.com</div>
        </div>
      </div>
    </div>
    <div class="mapBox">
       <img src="~@/assets/img/aboutUs/address.png" alt />
    </div>
      <div class="bottom">
      <div class="messageBox minBox">
        <div class="aboutSectionTitle aboutSectionTitleC">
          <div class="CNtitle">在线留言</div>
          <div class="ENtitle">ONLINE MESSAGE</div>
        </div>
        <div class="infoListTop">
          <div class="infoItem">
            <input type="text" class="input" v-model="userdata.userName" placeholder="姓名 Name"/>
          </div>
          <div class="infoItem">
            <input type="text" class="input" v-model="userdata.tel" placeholder="联系方式 Tel"/>
          </div>
          <div class="infoItem">
            <input type="text" class="input" v-model="userdata.email" placeholder="邮箱 Email"/>
          </div>
        </div>
        <div class="infoListBot">
          <div class="infoItem">
            <input type="text" class="input" maxlength="200" v-model="userdata.message" placeholder="留言 Message 200字以内"/>
          </div>
        </div>
        <div class="commitBtn" @click="commitInfo">提交留言</div>
      </div>
    </div>
  </div>
</template>
<script>
import {fetchAddMessage} from '@/api/index'
import {validatePhone,validateEmail} from '../../../utils/validate'
import { Message } from 'element-ui';
export default {
  name: "tabItem",
  data() {
    return {
      userdata: {
        userName: '',
        tel: '',
        email: '',
        message: ''
      }
    };
  },
  mounted() {
  },
  methods: {
    commitInfo() {
      // alert('提交留言')
      if(!this.userdata.userName) {
        Message.error('请输入姓名')
        return 
      }
      if(!validatePhone(this.userdata.tel)) {
        Message.error('请输入正确的手机')
        return 
      }
      if(!validateEmail(this.userdata.email)) {
        Message.error('请输入正确的邮箱')
        return 
      }
      if(!this.userdata.message) {
        Message.error('请输入消息')
        return 
      }
      fetchAddMessage(this.userdata).then(res => {
        console.log(res)
        if(res.data.code===0) {
          Message.success('提交成功')
          this.userdata = {
                    userName: '',
        tel: '',
        email: '',
        message: ''
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.tabItem {
  position: relative;
  .top {
    height: 566px;
    width: 100%;
    background: #fff;
    .lxList {
      display: flex;
      justify-content: space-around;
      text-align: center;
      .lxItem {
        width: 380px;
        box-sizing: border-box;
        padding-top: 106px;
        .icon {
          width: 88px;
          height: 88px;
          margin: 0 auto;
        }
        .ic_b {
          border:2px solid #D5262B;
          border-radius: 50%;
          line-height: 84px;
          img {
            width: 44px;
            height: 44px;
          }
        }
        .name {
          font-size: 20px;
          margin-top: 42px;
          color: #333;
        }
        .info {
          font-size: 14px;
          margin-top: 20px;
          color: #666;
        }
      }
    }
  }
  .bottom {
    height: 700px;
    width: 100%;
    background: #f4f4f4;
    box-sizing: border-box;
    padding-top: 294px;
    .messageBox {
      .infoItem{
        input{
          background: none;
          border: none;
          border-bottom: 1px solid #CCC;
          line-height: 30px;
          font-size: 14px;
          color: #999;
          outline: none;
          width: 100%;
        }
      }
      .infoListTop{
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        .infoItem{
          width: 320px;
        }
      }
      .infoListBot{
        margin-top: 72px;
      }
      .commitBtn{
        width: 180px;
        line-height: 44px;
        border-radius: 23px;
        border: 1px solid #999;
        text-align: center;
        font-size: 14px;
        color: #999;
        cursor: pointer;
        margin: 60px auto 0;
      }
    }
  }
  .mapBox{
    width: 1200px;
    height: 432px;
    border: 1px solid #E6E6E6;
    box-sizing: border-box;
    padding: 30px 20px;
    position: absolute;
    left: 0;
    right: 0;
    top: 366px;
    margin: auto;
    background: #fff;
    img  { 
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/components/tabItem4.vue